import { cloneDeep } from "lodash";
import {
  emptyWorksheetGridClientFilters,
} from "src/app/core/models/admissions.model";
import { AdmissionsService } from "src/app/core/services/admissions.service";
import { WorksheetFilterSnapshot } from "./worksheet-saved-views.model";

function dosIsoRangeFromAdmissionsService(s: AdmissionsService): {
  filterDate: string;
  filterEndDate: string | null;
} {
  if (!s.worksheetUserCommittedDosRange) {
    return { filterDate: "", filterEndDate: null };
  }
  const sd = s.selectedDate;
  const start = new Date(sd.startDate);
  const end = new Date(sd.endDate);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  const filterDate = start.toISOString();
  const filterEndDate = start.getTime() === end.getTime() ? null : end.toISOString();
  return { filterDate, filterEndDate };
}

/** Snapshot of live {@link AdmissionsService} worksheet filters (sidebar Apply, localStorage, saved views). */
export function buildWorksheetFilterSnapshotFromAdmissions(
  admissions: AdmissionsService
): WorksheetFilterSnapshot {
  const { filterDate, filterEndDate } = dosIsoRangeFromAdmissionsService(admissions);
  return {
    filterDate,
    filterEndDate,
    referralSourceFilterList: cloneDeep(admissions.referralSourceFilterList ?? []),
    resourcesFilter: cloneDeep(admissions.resourcesFilter ?? []),
    locationFilter: cloneDeep(admissions.locationFilter ?? []),
    visitTypeFilter: cloneDeep(admissions.visitTypeFilter ?? []),
    serviceFilter: cloneDeep(admissions.serviceFilter ?? []),
    encounerStatusList: cloneDeep(admissions.encounerStatusList ?? []),
    gridText: (() => {
      const g = cloneDeep({
        ...emptyWorksheetGridClientFilters(),
        ...(admissions.worksheetGridText ?? {}),
      });
      g.dobContains = "";
      g.nameContains = (admissions.searchQuery ?? "").trim();
      return g;
    })(),
    createdOnIso: admissions.worksheetCreatedOnIso ?? null,
    createdOnEndIso: admissions.worksheetCreatedOnEndIso ?? null,
    updatedOnIso: admissions.worksheetUpdatedOnIso ?? null,
    activityDateStartIso: admissions.worksheetActivityDateStartIso ?? null,
    activityDateEndIso: admissions.worksheetActivityDateEndIso ?? null,
  };
}
